import React, {FC, useContext} from "react";
import {Box, Typography} from "@material-ui/core";
import formatPrice from "tools/formats/formatPrice";
import {CurrencyContext} from "view/context/CurrencyContext";
import Fee from "ts/api/fee";
import useStyles from "./styles";

type Props = {
  fee: Fee;
};

const FeeItem: FC<Props> = ({fee}) => {
  const classes = useStyles();
  const currency = useContext(CurrencyContext);

  return (
    <Box>
      <Box className={classes.fee}>
        <Box className={classes.feeContent}>
          <Typography variant="body2" className={classes.feeName}>
            {fee.name}
          </Typography>
          <Box width="80px" textAlign="right">
            <Typography>
              {formatPrice(fee?.amountWithFees, currency)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FeeItem;
